module.exports = __webpack_public_path__ + "img/capa2.7fc75c10.webp";